import { render, staticRenderFns } from "./CmgPageNotFound.vue?vue&type=template&id=c8edb152&scoped=true&lang=pug"
import script from "./cmg-page-not-found.ts?vue&type=script&lang=ts&external"
export * from "./cmg-page-not-found.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPageNotFound.vue?vue&type=style&index=0&id=c8edb152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8edb152",
  null
  
)

export default component.exports